import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const CircleRadioWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  justify-self: center;
`;

export const CircleRadioLabel = styled.label`
  cursor: pointer;
`;

export const CircleRadioSpan = styled.span`
  padding: 0;
  margin: 0;
  display: grid;
  justify-content: center;
  align-items: center;
  width: ${props => (props.$diameter || '22px')};
  height: ${props => (props.$diameter || '22px')};
  border-radius: 50%;
  border: ${props => (props.$border || '2px solid')};
  border-color: ${props => (props.$color || (props.$selected ? colors.primary : colors.black))};

  &::after {
    visibility: ${props => (props.$selected ? 'visible' : 'hidden')};
    content: '';
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background-color: ${props => (props.$color || (props.$selected ? colors.primary : colors.black))};
  }
`;

export const CircleRadioInput = styled.input`
  display: none;
`;
